import React from 'react';
import {
	Radar,
	RadarChart,
	Tooltip,
	PolarGrid,
	PolarAngleAxis,
	PolarRadiusAxis,
	ResponsiveContainer,
} from 'recharts';
import { blue_pilu } from '../../../helpers/utils';
import Title from './Title';

export const RadarGraph = ({ divisions = [] }) => {
	return (
		<>
			<Title>Número total de pedidos (global)</Title>
			<ResponsiveContainer width='100%' height='100%'>
				<RadarChart
					cx='50%'
					cy='50%'
					outerRadius='80%'
					data={divisions}
				>
					<PolarGrid />
					<PolarAngleAxis dataKey='subject' />
					<PolarRadiusAxis />
					<Tooltip />
					<Radar
						name='Pedidos'
						dataKey='number'
						stroke={blue_pilu}
						fill={blue_pilu}
						fillOpacity={0.6}
					/>
				</RadarChart>
			</ResponsiveContainer>
		</>
	);
};

// 5585266665
